import { ComponentName, ExtractType } from '@publishing-engine/domain/types';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

export function getFieldConfig<CN extends ComponentName>(
  formFields: Omit<FormFieldDefinition, 'caseDataFields'>[],
  componentName: CN
) {
  const found = formFields?.find(cfg => cfg.name === componentName) ?? null;

  return found as ExtractType<FormFieldDefinition, CN> | null;
}
